
const attachProductObserver = (target) => {
	const observer = new MutationObserver(() => {
		for (const node of target.querySelectorAll('li.snize-product')) {
			// Get product properties
			const title = node.querySelector('.snize-title').textContent.trim();
			const image = node.querySelector('.snize-item-image').src;
			const url = node.querySelector('a[href*="/products/"]').href;
			const qatc = node.closest('.snize-ac-results') == null;

			// Create new div element so we can attach shadow DOM
			const div = document.createElement('div');
			for (const attr of node.attributes) div.setAttribute(attr.name, attr.value);
			div.append(...node.children);

			// Attach shadow
			window.attachProductCard(div, { title, image, url, qatc });
			node.replaceWith(div);
		}
	});

	observer.observe(target, { childList: true, subtree: true });
}

const results = document.getElementById('snize_results');
if (results) attachProductObserver(document.getElementById('PageContainer'))

const popupObserver = new MutationObserver(entries => {
	for (const entry of entries) {
		for (const node of entry.addedNodes) {
			if (node instanceof HTMLElement && node.matches('.snize-ac-results')) {
				attachProductObserver(node);
				popupObserver.disconnect();
			}
		}
	}
});

popupObserver.observe(document.body, { childList: true });

// Toggle modal when clicking on mobile search icon
document.querySelector('.site-header__search-toggle').addEventListener('click', () => {
	document.getElementById('search-bar__input').dispatchEvent(new Event('mousedown'));
});